import { generatePath, matchRoutes } from "react-router-dom";
import routes from "./routes";
import { ROLES } from "../constants";

// Landing page per role; it is the first breadcrumb on every other page.
export const HOME_BY_ROLE = {
  [ROLES.ADMIN]:    "/admin/dashboard",
  [ROLES.HR]:       "/hr/dashboard",
  [ROLES.EMPLOYEE]: "/employee/dashboard",
  [ROLES.MANAGER]:  "/employee/dashboard",
};

// routes.js imports pages that (via components/ui) import this module, so the
// route table must only be read lazily, never at module evaluation time.
let protectedRoutes;
const getProtectedRoutes = () => {
  if (!protectedRoutes) {
    protectedRoutes = [...routes.admin, ...routes.employee, ...routes.hr, ...routes.profile];
  }
  return protectedRoutes;
};

const findRouteByPath = (path) => getProtectedRoutes().find((r) => r.path === path);

// matchRoutes ranks static segments above params, so /hr/employees/new wins over /hr/employees/:id.
export const matchPageRoute = (pathname) => {
  const matches = matchRoutes(getProtectedRoutes().map((route) => ({ path: route.path, route })), pathname);
  if (!matches?.length) return null;
  const { route, params } = matches[matches.length - 1];
  return { route: route.route, params };
};

/**
 * Resolves the header title and the ancestor breadcrumbs for a pathname.
 * The current page is not part of `crumbs`; it is rendered as the header title.
 */
export const getPageMeta = (pathname, { role, titleOverride } = {}) => {
  const match = matchPageRoute(pathname);
  if (!match) return { title: titleOverride || "", crumbs: [] };

  const { route, params } = match;
  const title = titleOverride || route.title || "";

  const ancestors = [];
  let root = route;
  let parentPath = route.parent;
  while (parentPath) {
    const parent = findRouteByPath(parentPath);
    if (!parent) break;
    ancestors.unshift({ label: parent.title, href: generatePath(parent.path, params) });
    root = parent;
    parentPath = parent.parent;
  }

  const crumbs = [];
  const homeHref = HOME_BY_ROLE[role];
  if (homeHref && homeHref !== pathname) {
    crumbs.push({ label: "Home", href: homeHref, isHome: true });
  }
  if (root.section) crumbs.push({ label: root.section });
  crumbs.push(...ancestors);

  return { title, crumbs };
};
